import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/LoginContext/AuthContext";
import Avatar from "react-avatar";
import { useTenantLogout } from "../../../../utils/authHelpers";
import { useSchlStudentNotification } from "../../../context/StudentNotificationContext/SchlStudentNotificationContext";
import { useGetUnreadCount } from "../../../../hooks/organization/notification/useGetUnreadCount";
import { getSubdomain } from "../../../../utils/subdomian";

export const ParentTopBar = ({ type }) => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const { tenantLogout } = useTenantLogout();
  const storedUser = JSON.parse(localStorage.getItem("tenant-user"));
  const finalUser = user || storedUser;
  const { unreadCount, setUnreadCount } = useSchlStudentNotification();
  const { getUnreadCount } = useGetUnreadCount();

  const authData = localStorage.getItem("user");
  const parsed = authData ? JSON.parse(authData) : null;
  const parentType = parsed?.user?.parent_type;
  const currentDashboard = window.location.pathname.startsWith("/school-parent")
    ? "school_parent"
    : "normal_parent";

  const isSubdomain = () => Boolean(getSubdomain());

  const handleLogout = () => {
    if (isSubdomain()) {
      tenantLogout(); // ✅ subdomain-safe logout
    } else {
      logout(); // ✅ main domain or normal parent
    }
  };

  useEffect(() => {
    const fetchInitialCount = async () => {
      const count = await getUnreadCount({ type });
      if (count !== null && count !== undefined) {
        setUnreadCount(count);
      }
    };

    fetchInitialCount();
  }, [type]);

  return (
    <nav className="navbar navbar-expand-lg yuva-navbar">
      <div className="row w-100 g-1 align-items-center">
        {/* Left Side - Logo */}
        <div className="col-lg-9 col-md-9 col-sm-9 col-6 d-flex align-items-center">
          <Link
            to={
              currentDashboard === "normal_parent"
                ? "/parent/dashboard"
                : "/school-parent/dashboard"
            }
            className="d-flex align-items-center"
          >
            {/* https://yuvaquest-public-bucket-s3.s3.us-east-2.amazonaws.com/static/logo-YQ/YQ_LOGO_TEXT_WHITE.png */}
            <img
              src="https://d2lvj32mp5x83n.cloudfront.net/static/logo-YQ/YQ_LOGO_TEXT_WHITE.png"
              alt="Logo"
              className="YQTopBarLogo"
            />
          </Link>
        </div>

        {/* Right Side - Welcome Text + Avatar */}
        <div className="col-lg-3 col-md-3 col-sm-3 col-6 d-flex justify-content-end align-items-center">
          {currentDashboard === "school_parent" ? (
            <div
              className="notification-bell me-3 position-relative"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/school-parent/reciever/notifications")}
            >
              <i
                className="fa-solid fa-bell"
                style={{ fontSize: "20px", color: "#ffffff" }}
              ></i>
              {unreadCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-5px",
                    backgroundColor: "#0d6efd",
                    color: "white",
                    borderRadius: "50%",
                    padding: "2px 6px",
                    fontSize: "8px",
                  }}
                >
                  {unreadCount}
                </span>
              )}
            </div>
          ) : null}

          <p className="welcome text-white mb-0 me-2">
            <span className="fw-bold">
              {finalUser?.user?.firstName ||
                finalUser?.firstName ||
                finalUser?.name}
            </span>
          </p>
          <div className="btn-group">
            <p
              type="button"
              className="dropdown-toggle mb-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <Avatar
                name={
                  finalUser?.user?.firstName ||
                  finalUser?.firstName ||
                  finalUser?.name
                }
                color="#667085"
                round="20px"
                size="35"
              />
            </p>
            <ul className="dropdown-menu dropdown-menu-end">
              {/* Switch option ONLY for mixed parent */}
              {parentType === "mixed" && (
                <>
                  {currentDashboard === "normal_parent" ? (
                    <li>
                      <Link
                        className="dropdown-item"
                        to="/school-parent/dashboard"
                      >
                        Switch to School
                      </Link>
                    </li>
                  ) : (
                    <li>
                      <Link className="dropdown-item" to="/parent/dashboard">
                        Switch to Personal
                      </Link>
                    </li>
                  )}
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                </>
              )}

              <li>
                <Link
                  className="dropdown-item"
                  to={
                    currentDashboard === "normal_parent"
                      ? "/parent/settings"
                      : "/school-parent/settings"
                  }
                >
                  Profile
                </Link>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>

              <li>
                <Link className="dropdown-item" onClick={handleLogout}>
                  Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
